import { Camera } from './Camera'
import {
  CameraTypeOption,
  cameraTypes,
} from './CameraTypes'


interface ConfiguredCameraDataParams {
  camera: Camera
  configFile?: File
  configName?: string
  thumbnail?: File
  viewName: string
  viewPath: string
}

export class ConfiguredCameraData {
  camera: Camera
  configFile?: File
  configName?: string
  thumbnail?: File
  viewName: string
  viewPath: string

  constructor (data: ConfiguredCameraDataParams) {
    this.camera = data.camera
    this.configFile = data.configFile
    this.configName = data.configName
    this.thumbnail = data.thumbnail
    this.viewName = data.viewName
    this.viewPath = data.viewPath
  }

  get cameraType (): CameraTypeOption | undefined {
    return cameraTypes.find(type => type.value === this.camera.cameraType)
  }

  get name (): string {
    return this.camera.name
  }
}
